import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";

import { SharedModule } from "src/app/shared/shared.module";

import { FlatComponent } from "./flat";
import { ModalComponent } from "./modal";

/**
 * OpenEMS-style Angular module for the Cost-Revenue widget.
 */
@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule,
        SharedModule,
    ],
    declarations: [
        FlatComponent,
        ModalComponent,
    ],
    exports: [
        FlatComponent,
    ],
})
export class ControllerEnergyCostRevenueModule { }
